<template>
  <v-card variant="outlined">
    <v-card-title class="text-subtitle-2 font-weight-bold">
      {{ $t("ncrm.integrations.externalApi.samples.title") }}
    </v-card-title>
    <v-card-text class="d-flex flex-column ga-4">
      <div class="d-flex flex-wrap ga-2">
        <v-chip color="success">
          {{ endpoint.routing_mode || "store_only" }}
        </v-chip>
        <v-chip color="info">
          {{ endpoint.entity_scope || "company" }}
        </v-chip>
        <v-chip color="secondary">
          {{ endpoint.template_key || "custom" }}
        </v-chip>
      </div>

      <div v-if="templateDescription" class="text-body-2 text-medium-emphasis">
        {{ templateDescription }}
      </div>

      <div>
        <div class="text-caption text-medium-emphasis mb-2">
          {{ $t("ncrm.integrations.externalApi.samples.curlTitle") }}
        </div>
        <pre class="ncrm-external-api-endpoint-samples__pre">{{ sampleCurl }}</pre>
      </div>

      <div>
        <div class="text-caption text-medium-emphasis mb-2">
          {{ $t("ncrm.integrations.externalApi.samples.payloadTitle") }}
        </div>
        <pre class="ncrm-external-api-endpoint-samples__pre">{{ prettyPayload }}</pre>
      </div>

      <v-alert type="info" density="comfortable">
        {{ $t("ncrm.integrations.externalApi.samples.futureHint") }}
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  buildExternalApiSampleCurl,
  buildExternalApiSamplePayload,
  findExternalApiTemplate,
  prettyPrintExternalApiJson,
} from "@/Utile/ncrmExternalApi.mjs";

export default {
  name: "NcrmExternalApiEndpointSamplesCard",
  props: {
    endpoint: {
      type: Object,
      default: () => ({}),
    },
    templates: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    resolvedTemplate() {
      return findExternalApiTemplate(this.templates, this.endpoint?.template_key);
    },
    templateDescription() {
      return this.resolvedTemplate?.description || "";
    },
    samplePayload() {
      return buildExternalApiSamplePayload(this.endpoint);
    },
    prettyPayload() {
      return prettyPrintExternalApiJson(this.samplePayload, "{}");
    },
    sampleCurl() {
      return buildExternalApiSampleCurl(this.endpoint, this.samplePayload);
    },
  },
};
</script>

<style scoped>
.ncrm-external-api-endpoint-samples__pre {
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.05);
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.84rem;
  font-family: var(--app-font-family-mono);
}
</style>
